var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactUsIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.07699 9.62049V8.08936C3.07699 7.58073 3.53295 7.12453 4.18088 7.12453C4.76282 7.12453 5.28477 7.52305 5.28477 8.08936V9.56281C5.28477 10.5853 4.31287 11.4348 3.14299 11.4348C1.9731 11.4348 1.0012 10.5801 1.0012 9.56281V6.33275C0.935207 3.38584 3.59894 1 6.9706 1C10.3423 1 13 3.38584 13 6.27507V9.50513C13 10.5276 12.0281 11.3771 10.8582 11.3771C9.68833 11.3771 8.71643 10.5276 8.71643 9.50513V8.03168C8.71643 7.52305 9.17238 7.06686 9.82032 7.06686C10.4023 7.06686 10.9242 7.46537 10.9242 8.03168V9.62049",
    stroke: "#021A37",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactUsIcon);
export default __webpack_public_path__ + "static/media/contact-us-icon.44c270fa41f0adf04a9dcf376e7b71e4.svg";
export { ForwardRef as ReactComponent };